import { format } from "date-fns"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { Calendar } from "../../../../ui/molecules/calendar"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../../ui/molecules/textArea"
import { OptionType } from "../../../../utils"
import { isNonComplianceMapping, nonComplianceMap } from "../../../../utils/measuresUtils"
import { GetAllOdc, resetGetAllOdcStatus } from "../../../odc/slice"
import { NonComplianceCode } from "../../NonComplianceCode"
import { NonComplianceCodeByIdDTO } from "../../NonComplianceCode/dto"
import { resetGetByIdStatus } from "../../NonComplianceCode/slice"
import { NonComplianceMapping } from "../dataService/dto"
import { setOtherOdcMeasureDescription, setOtherOdcMeasureIsReleased, setOtherOdcMeasureNonComplianceDescription, setOtherOdcMeasureNonComplianceOfficerId, setOtherOdcMeasuresCustomerId, setOtherOdcMeasuresDate, setOtherOdcMeasuresNonComplianceCode, setOtherOdcMeasuresOdc, setOtherOdcNewMeasureDescription, setOtherOdcNewMeasureIsReleased, setOtherOdcNewMeasureNonComplianceDescription, setOtherOdcNewMeasureNonComplianceOfficerId, setOtherOdcNewMeasuresCustomerId, setOtherOdcNewMeasuresDate, setOtherOdcNewMeasuresNewComplianceCode, setOtherOdcNewMeasuresNonComplianceVersion, setOtherOdcNewMeasuresOdc } from "../dataService/slice"

interface Props { measureType: 'old' | 'new' | undefined }

export function CustomerAddOtherOdcMeasueres(props: Props) {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const OtherOdcMeasuresState = useAppSelector(state => state.OtherOdcMeasuresState)
    const odcState = useAppSelector(state => state.odc)
    const NonComplianceCodesState = useAppSelector(state => state.NonComplianceCodes)
    const [odc, setOdc] = useState<OptionType[]>([])
    const [selectedNcCode, setSelectedNcCode] = useState<string>('')
    const [selectedNcInfoOld, setSelectedNcInfoOld] = useState<NonComplianceMapping | null>(null)
    const [selectedNcInfoNew, setSelectedNcInfoNew] = useState<NonComplianceCodeByIdDTO | null>(null)

    const handleSelectedNc = (value: string) => {
        setSelectedNcCode(value)
        const infoNc = nonComplianceMap.get(value) || null
        if (infoNc && isNonComplianceMapping(infoNc)) setSelectedNcInfoOld(infoNc)
    }

    useEffect(() => {
        if (props.measureType === 'old') {
            dispatch(setOtherOdcMeasuresCustomerId(sessionState.selected.customerId))
            dispatch(setOtherOdcMeasureIsReleased(false))
            dispatch(setOtherOdcMeasureNonComplianceOfficerId(sessionState.selected.officerId))
        }
        if (props.measureType === 'new') {
            dispatch(setOtherOdcNewMeasuresNonComplianceVersion('NEW'))
            dispatch(setOtherOdcNewMeasuresCustomerId(sessionState.selected.customerId))
            dispatch(setOtherOdcNewMeasureIsReleased(false))
            dispatch(setOtherOdcNewMeasureNonComplianceOfficerId(sessionState.selected.officerId))
        }
    }, [])

    useEffect(() => {
        if (NonComplianceCodesState.ConComplianceCodeResponseByIdStatus === 'successfully') {
            dispatch(resetGetByIdStatus())
            setSelectedNcInfoNew(NonComplianceCodesState.ConComplianceCodeResponseById)
        }
    }, [NonComplianceCodesState.ConComplianceCodeResponseByIdStatus])

    useEffect(() => {
        dispatch(GetAllOdc({ itemsPerPage: 0, page: 0 }))
    }, [])

    useEffect(() => {
        if (odcState.getAllOdcStatus === 'successfully' && odcState.getAllOdcResponse !== undefined) {
            dispatch(resetGetAllOdcStatus())
            setOdc(odcState.getAllOdcResponse.data.map(o => ({ value: o.id, label: o.code + ' - ' + o.companyName } as OptionType)))
        }
    }, [odcState.getAllOdcStatus])

    return (
        <div className="flex flex-col gap-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Provvedimenti </span>
                    <span className="text-brandPrimary-300">/</span>
                    <span className="text-brandPrimary-100 font-semibold"> Dati Non Conformità</span>
                </div>
                <div className="p-6 flex flex-col gap-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <MadfarmStaticSelect
                            menuPortalTargetIsNotBody
                            label="Organismo di controllo"
                            placeholder="ODC"
                            value={props.measureType === 'old' ? OtherOdcMeasuresState.OtherOdcMeasuresCreationUpdate.odcId : OtherOdcMeasuresState.OtherOdcNewMeasuresCreationUpdate.odcId}
                            options={odc}
                            onChange={(value) => {
                                //@ts-ignore
                                const v = value?.value ?? null
                                if (props.measureType === 'old') dispatch(setOtherOdcMeasuresOdc(v))
                                if (props.measureType === 'new') dispatch(setOtherOdcNewMeasuresOdc(v))
                            }}
                            noOptionsMessage={""}
                        />
                        <Calendar
                            label="Data Provvedimento"
                            errorLabel={OtherOdcMeasuresState.otherOdcMeasuserOldErrors.measureDate ? 'Data mancante' : undefined}
                            selected={props.measureType === 'old' ? OtherOdcMeasuresState.OtherOdcMeasuresCreationUpdate.measureDate : OtherOdcMeasuresState.OtherOdcNewMeasuresCreationUpdate.measureDate}
                            onChange={(date) => {
                                const formatted = format(new Date(date), 'yyyy-MM-dd')
                                if (props.measureType === 'old') dispatch(setOtherOdcMeasuresDate(formatted))
                                if (props.measureType === 'new') dispatch(setOtherOdcNewMeasuresDate(formatted))
                            }}
                        />
                    </div>
                    <NonComplianceCode
                        value={selectedNcCode}
                        type={props.measureType}
                        onChange={(value) => {
                            if (props.measureType === 'old') dispatch(setOtherOdcMeasuresNonComplianceCode(value))
                            if (props.measureType === 'new') dispatch(setOtherOdcNewMeasuresNewComplianceCode(value))
                            if (value) handleSelectedNc(value)
                        }}
                    />
                    <TextArea
                        label="Descrizione non conformità"
                        onChangeText={(text) => {
                            if (props.measureType === 'old') dispatch(setOtherOdcMeasureNonComplianceDescription(text))
                            if (props.measureType === 'new') dispatch(setOtherOdcNewMeasureNonComplianceDescription(text))
                        }}
                    />
                </div>
            </div>
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Provvedimenti </span>
                    <span className="text-brandPrimary-300">/</span>
                    <span className="text-brandPrimary-100 font-semibold"> Dati Provvedimento</span>
                </div>
                <div className="p-6">
                    <TextArea
                        label="Descrizione Provvedimento"
                        onChangeText={(text) => {
                            if (props.measureType === 'old') dispatch(setOtherOdcMeasureDescription(text))
                            if (props.measureType === 'new') dispatch(setOtherOdcNewMeasureDescription(text))
                        }}
                    />
                </div>
            </div>
        </div>
    )
}